import React from "react";
import { Col, Container, Row } from "reactstrap";
// Components

export default class ResponsibleDisclosure extends React.Component {
  render() {
    return (
      <div>
        <div id="privacy">
          <Container>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="section">
                <h2><strong>Responsible Disclosure Policy</strong></h2>
<p>&nbsp;</p>
<p>At Trevel, trust is our #1 value and we take the protection of our customers' data very seriously.</p>
<p>&nbsp;</p>
<p>The Trevel security team acknowledges the valuable role that independent security researchers play in internet security. As a result, we encourage responsible reporting of any vulnerabilities that may be found in our site or applications. Trevel is committed to working with security researchers to verify and address any potential vulnerabilities that are reported to us.</p>
<p>&nbsp;</p>
<p>As a component of responsible disclosure, Trevel will notify potentially impacted customers when they must take action to patch or otherwise remediate a vulnerability in advance of publicly disclosing the issue and releasing a CVE.</p>
<p>&nbsp;</p>
<p>Please review these terms before you test and/or report a vulnerability. Trevel pledges not to initiate legal action against researchers for penetrating or attempting to penetrate our systems as long as they adhere to this policy.</p>
<p>&nbsp;</p>
<h2><strong>Testing for security vulnerabilities:</strong></h2>
<p>&nbsp;</p>
<p>Whenever a Trial or Developer Edition is available, please conduct all vulnerability testing against such instances. Always use test or demo accounts when testing our online services.</p>
<p>&nbsp;</p>
<p>For information about security assessments, requirements, restrictions, and scheduling, review the knowledge article titled "Vulnerability Assessment and Penetration Test".</p>
<h2><strong>Reporting a potential security vulnerability:</strong></h2>
<p>&nbsp;</p>
<ul>
<li>Privately share details of the suspected vulnerability with Trevel by sending an email to contact@Trevel.com</li>
<li>Provide full details of the suspected vulnerability so the Trevel security team may validate and reproduce the issue</li>
</ul>
<h2><strong>Trevel does not permit the following types of security research:</strong></h2>
<p>&nbsp;</p>
<p>While we encourage you to discover and report to us any vulnerabilities you find in a responsible manner, the following conduct is expressly prohibited:</p>
<p>&nbsp;</p>
<ul>
<li>Performing actions that may negatively affect Trevel or its users (e.g. Spam, Brute Force, Denial of Service&hellip;)</li>
<li>Accessing, or attempting to access, data or information that does not belong to you</li>
<li>Destroying or corrupting, or attempting to destroy or corrupt, data or information that does not belong to you</li>
<li>Conducting any kind of physical or electronic attack on Trevel personnel, property or data centers</li>
<li>Social engineering any Trevel service desk, employee or contractor</li>
<li>Conduct vulnerability testing of participating services using anything other than test accounts (e.g. Developer or Trial Edition instances)</li>
<li>Violating any laws or breaching any agreements in order to discover vulnerabilities</li>
</ul>
<h2><strong>The Trevel security team commitment:</strong></h2>
<p>&nbsp;</p>
<p>We ask that you do not share or publicize an unresolved vulnerability with/to third parties. If you responsibly submit a vulnerability report, the Trevel security team and associated development organizations will use reasonable efforts to:</p>
<p>&nbsp;</p>
<ul>
<li>Respond in a timely manner, acknowledging receipt of your vulnerability report</li>
<li>Provide an estimated time frame for addressing the vulnerability report</li>
<li>Notify you when the vulnerability has been fixed</li>
</ul>
<p>&nbsp;</p>
<p>We are happy to thank every individual researcher who submits a vulnerability report helping us improve our overall security posture at Trevel.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}
